import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';

// Bootstrap the application immediately
// MSAL will be initialized lazily when needed
bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
